import React from "react";

export const Confirm = (props) => {
  return (
    <div className="confirm_container">
      <div className="confirm_modal_container">
        <p>{props.title}</p>
        <div className="confirm_btn_container">
          <span className="confirm_btn" onClick={props.yes}>
            {props.ok}
          </span>
          <span className="confirm_btn" onClick={props.no}>
            {props.cancel}
          </span>
        </div>
      </div>
    </div>
  );
};
